
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  onClick, 
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseClasses = 'font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap';
  
  const variantClasses = {
    primary: 'bg-[#9B1F3A] text-white hover:bg-[#7A1A2E]',
    secondary: 'bg-gray-800 text-white hover:bg-gray-700',
    outline: 'border-2 border-[#9B1F3A] text-[#9B1F3A] hover:bg-[#9B1F3A] hover:text-white'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {children}
    </button>
  );
}
